import React from "react";
import { useRoutes } from "react-router-dom";
import SignIn from "../pages/sign_in/SignIn";
import SignUp from "../pages/sign_up/SignUp";
import Cases from "../pages/cases/Cases";
import Account from "../pages/account/Account";
import NotFound from "../pages/404/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedAdminRoute from "./ProtectedAdminRoute";
import Suites from "../pages/suites/Suites";
import SuiteEdit from "../pages/suites/SuiteEdit";
import SuitCreate from "../pages/suites/components/create_suite/SuiteCreate";
import FilterCase from "../pages/cases/CaseByStatus";
import Admin from "../pages/account/admin/Admin";
import CaseEdit from "../pages/cases/CaseEdit";
import CaseView from "../pages/cases/CaseView";
import SuiteStat from "../pages/suites/SuiteStat";
import Agent from "../pages/account/admin/pages/Agent/Agent";
import AgentEdit from "../pages/account/admin/pages/Agent/AgentEdit";
import AgentView from "../pages/account/admin/pages/Agent/AgentView";
import AgentResources from "../pages/account/admin/pages/Agent/AgentResources";
import SystemRegistry from "../pages/account/admin/pages/SystemRegistry/SystemRegistry";
import DownloadPage from "../pages/download/Download";
import SystemRegistryCreate from "../pages/account/admin/pages/SystemRegistry/SystemRegistryCreate";
import CaseBySuite from "../pages/cases/CaseBySuite";
import Users from "../pages/account/admin/pages/Users/Users";
import UserGroups from "../pages/account/admin/pages/UserGroup/UserGroup";
import CaseByAgent from "../pages/cases/CaseByAgent";
import Notifications from "../pages/notification/Notification";
import Dashboard from "../pages/dashboard/Dashboard";
import UserEdit from "../pages/account/admin/pages/Users/UserEdit";
import CatalogProcedure from "../pages/account/admin/pages/Procedures/CatalogProcedure";
import ServiceProcedure from "../pages/account/admin/pages/Procedures/ServiceProcedure";
import ProcedurePage from "../pages/account/admin/pages/Procedures/Procedure";
import SelectAgent from "../pages/account/admin/pages/Procedures/SelectAgent";
import AgentProcedures from "../pages/account/admin/pages/Agent/AgentProcedures";
import Versions from "../pages/account/admin/pages/Versions/Versions";
import ProductCatalog from "../pages/account/admin/pages/ProductCatalog/ProductCatalog";
import ProductCreate from "../pages/account/admin/pages/ProductCatalog/ProductCreate";
import Artifacts from "../pages/artifacts/Artifacts";
import Instances from "../pages/account/admin/pages/Instances/Instances";
import InstanceView from "../pages/account/admin/pages/Instances/InstanceView";
import RequestResetPassword from "../pages/reset_password/RequestResetPassword";
import ResetPassword from "../pages/reset_password/ResetPassword";
import MainLayout from "../components/MainLayout";
import BlankLayout from "../components/BlankLayout";
import ProductManagementTabs from "../pages/account/admin/pages/ProductCatalog/ProductManagement";
import ProductDataCreate from "../pages/account/admin/pages/ProductCatalog/ProductDataCreate";
import CasesByTagPage from "../pages/tags/Tags";
import AgentsQueue from "../pages/agents/AgentsQueue";

const AppRouter = () => {
  const routes = [
    {
      element: <BlankLayout />,
      children: [
        { path: "signin", element: <SignIn /> },
        { path: "signup", element: <SignUp /> },
        { path: "reset-password/request", element: <RequestResetPassword /> },
        { path: "reset-password", element: <ResetPassword /> },
      ],
    },

    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          element: <ProtectedRoute />,
          children: [
            { index: true, element: <Dashboard /> },
            { path: "account", element: <Account /> },
            { path: "notifications", element: <Notifications /> },
            { path: "download", element: <DownloadPage /> },

            {
              path: "suites",
              children: [
                { index: true, element: <Suites /> },
                { path: "create", element: <SuitCreate /> },
                { path: "create/link/:selectedId", element: <SuitCreate /> },
                { path: "create/artifact/:selectedId", element: <SuitCreate /> },
                { path: "create/upload", element: <SuitCreate /> },
                { path: "create/fill", element: <SuitCreate /> },
                { path: ":suitId", element: <Suites /> },
                { path: ":suitId/edit", element: <SuiteEdit /> },
                { path: ":suitId/view", element: <SuiteStat /> },
              ],
            },

            {
              path: "cases",
              children: [
                { index: true, element: <Cases /> },
                { path: ":caseId/edit", element: <CaseEdit /> },
                { path: ":caseId/view", element: <CaseView /> },
                { path: ":suitId/:statusType", element: <FilterCase /> },
                { path: ":suitId", element: <CaseBySuite /> },
              ],
            },

            {
              path: "agents",
              children: [{ index: true, element: <AgentsQueue /> }],
            },

            {
              path: "artifacts",
              children: [{ index: true, element: <Artifacts /> }],
            },
            {
              path: "coverage",
              children: [{ index: true, element: <CasesByTagPage /> }],
            },
            {
              // legacy path — kept so existing /hierarchy links still work
              path: "hierarchy",
              children: [{ index: true, element: <CasesByTagPage /> }],
            },
            {
              path: "management",
              element: <ProtectedAdminRoute />,
              children: [
                { index: true, element: <Admin /> },
                { path: "agents", element: <Agent /> },
                { path: "agents/:agentId/edit", element: <AgentEdit /> },
                { path: "agents/:agentId/view", element: <AgentView /> },
                {
                  path: "agents/:agentId/resources",
                  element: <AgentResources />,
                },
                {
                  path: "agents/:agentId/procedures",
                  element: <AgentProcedures />,
                },
                { path: "agents/:agentId/cases", element: <CaseByAgent /> },

                { path: "system-registry", element: <SystemRegistry /> },
                {
                  path: "system-registry/create",
                  element: <SystemRegistryCreate />,
                },
                {
                  path: "system-registry/edit/:id/:type",
                  element: <SystemRegistryCreate />,
                },

                { path: "procedures", element: <ProcedurePage /> },
                { path: "procedures/select-agent", element: <SelectAgent /> },

                { path: "users", element: <Users /> },
                { path: "users/:userId/edit", element: <UserEdit /> },
                { path: "groups", element: <UserGroups /> },
                { path: "versions", element: <Versions /> },
                { path: "products", element: <ProductManagementTabs /> },
                { path: "products-type/create", element: <ProductCreate /> },
                { path: "products-type/edit", element: <ProductCreate /> },
                {
                  path: "products-tags/create",
                  element: <ProductDataCreate />,
                },
                { path: "products-tags/edit", element: <ProductDataCreate /> },
                { path: "instances", element: <Instances /> },
                { path: "instances/:name/view", element: <InstanceView /> },
              ],
            },
          ],
        },
        { path: "*", element: <NotFound /> },
      ],
    },
  ];

  return useRoutes(routes);
};

export default AppRouter;
